/**
 * Root Layout Navigation Configuration
 *
 * This file defines URL patterns that control navigation behavior across mobile and desktop layouts.
 * All patterns support dynamic segments (e.g., $id) for route matching.
 */

/**
 * Mobile Bottom Navigation Control
 * URL patterns where mobile BottomNavigation should be hidden.
 *
 * These routes hide the bottom nav for:
 * - Authentication/onboarding flows (immersive full-screen experience)
 * - Content creation/editing interfaces (maximize screen space)
 * - Settings pages (cleaner focused UI)
 */
export const HIDDEN_BOTTOM_NAV_URLS = [
    // Auth & Onboarding Routes - Full-screen immersive experience
    '/onboarding',
    '/pricing',
    '/checkout',
    '/checkout-return',
    '/login',
    '/register/preferences',
    '/register',
    '/register/username',
    '/register/instagram',
    '/register/account-type',
    '/forgot-password',
    '/forgot-password/sent',
    '/reset-password',
    '/logout',
    '/verify-email',

    // Documents Routes
    '/privacy-policy',
    '/terms-of-use',
    '/terms-and-conditions',
    '/extension-privacy-policy',
    '/sitemap',

    // Content Creation/Editing Routes - Maximize workspace
    '/looks/create',
    '/collections/$id/edit',
    '/collections/$id/edit-details',

    // Settings Routes - Focused settings UI
    '/settings/wallet',
    '/settings/',
    '/settings/subscriptions/price',
    '/settings/feedback',
    '/settings/account/change-password',
]

/**
 * Desktop Top Navigation Override
 * URL patterns that should show desktop top navbar even when mobile bottom nav is hidden.
 *
 * This creates different UX patterns for mobile vs desktop:
 * - Mobile: Hide bottom nav for immersive full-screen editing/settings
 * - Desktop: Show top navbar for consistent navigation (more screen space available)
 */
export const DESKTOP_NAV_VISIBLE_URLS = [
    // Content Creation/Editing Routes - Desktop keeps navbar for context and navigation
    '/collections/$id/edit',
    '/collections/$id/edit-details',
    '/looks/create',

    // Settings Routes - Desktop keeps navbar for easy navigation between settings
    '/settings/wallet',
    '/settings/',
    '/settings/subscriptions/price',
    '/settings/feedback',
    '/settings/account/change-password',
]
